import { render, staticRenderFns } from "./RevenueStatistics.vue?vue&type=template&id=3051e6e8&scoped=true"
import script from "./RevenueStatistics.vue?vue&type=script&lang=js"
export * from "./RevenueStatistics.vue?vue&type=script&lang=js"
import style0 from "./RevenueStatistics.vue?vue&type=style&index=0&id=3051e6e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3051e6e8",
  null
  
)

export default component.exports